import { fetchAPI } from "../../../lib/fetchAPI.js";

export async function load({ params }) {
  let res = await fetchAPI(`/communitychronicle/slug/${params.slug}`, "GET", null, false);
  return {
    ...await res.json()
  }
}
